module.exports = __webpack_public_path__ + "img/text2.d98ecdf1.gif";